import React from 'react';
import { useLocation } from 'react-router-dom';
import Tictactoe from '../tictactoe/Tictactoe';
import Item from './Item';

const Portfolio = () => {
  const params = useLocation();

  if (params.pathname.includes('tictactoe')) {
    return (
      <div>
        <Tictactoe />
      </div>
    )
  }

  return (
    <div className="ui">
      <div className="ui internally stackable grid">
        <div className="row"></div>
        <div className="row">
          <div className="three wide column"></div>
          <div className="ten wide column">
            <h3>List of 'just for fun' projects</h3>
            <div class="ui list">
              <Item
                title="This website"
                description = "<b>ReactJS</b> + AWS S3 + CI/CD"
                icon="window maximize"
                href="/"
              />
              <Item 
                title="Tic tac toe game" 
                description = "Migration in progress: <b>ReactJS</b> + <b>Python</b> + Lambda + CI/CD. Impossible to beat Tic Tac Toe small AI"
                icon="th"
                href="#"
              />
              <Item
                title="Fancy console logger"
                description = "Small npm <b>Typescript</b> package to practise TDD and typescript"
                icon="window maximize"
                href="https://github.com/danielprlo/fancy-console-logger"
                openTab={true}
              />
              <Item
                title="Graphs solver"
                description = "Small <b>Python</b> package to practise TDD and python to apply common graph theory algorithms"
                icon="window maximize"
                href="https://github.com/danielprlo/py-graph-solver"
                openTab={true}
              />
            </div>            
          </div>       
        </div>
      </div>
    </div>
  )
}

export default Portfolio;
